import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HeaderService } from '../header.service';
import RoutesserviceService from '../routesservice.service';
// import { Duration } from 'ngx-bootstrap/chronos/duration/constructor';
import moment, { Duration } from 'moment';
@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  public workingSaturdays = ["2021/09/11", "2021/10/09", "2021/10/23"];
  public otherOffDays: string[] = [];
  public otherOffDaysvalue: string[] = [];
  constructor(
    private httpClient: HttpClient,
    private Customeroutes: RoutesserviceService,
    private HeaderService: HeaderService
  ) {
    this.getHolidays()
  }

  getLateCheckInTime(checkIn: string, userID: number) {
    if (checkIn > "10:15" && checkIn < "10:30") {
      return 1.25
    } else if (checkIn > "10:29" && checkIn < "10:45") {
      return 1.50
    } else if (checkIn > "10:44" && checkIn < "11:00") {
      return 1.75
    } else if (checkIn > "10:59" && checkIn < "11:15") {
      return 2
    } else if (checkIn > "11:14" && checkIn < "11:30") {
      return 2.25
    } else if (checkIn > "11:29" && checkIn < "11:45") {
      return 2.50
    } else if (checkIn > "11:44" && checkIn < "12:00") {
      return 2.75
    } else if (checkIn > "11:59" && checkIn < "12:15") {
      return 3.0
    } else if (checkIn > "12:14" && checkIn < "12:30") {
      return 3.25
    } else if (checkIn > "12:29" && checkIn < "12:45") {
      return 3.50
    } else if (checkIn > "12:44" && checkIn < "13:00") {
      return 3.75
    } else if (checkIn > "12:59") {
      return 4.0
    }
    return 1
  }
  async getDashboardData() {
    return this.httpClient
      .post(this.Customeroutes.getDashboard(), '', {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          //if login is true the store it into local storage
          // localStorage.setItem('token', data.data.token);
          return data;
          // this.showSpinner=false;
        }
        return data;
      });
  }

  async getHolidays() {
    this.httpClient
      .post(this.Customeroutes.getHolidays(), '', {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          const holidays = data.data
          holidays.forEach((element: { date: string; day_name: string; }) => {
            this.otherOffDays.push(element.date)
            this.otherOffDaysvalue.push(element.day_name)
          });
        }
      });
  }


  async getTodayCheckIn() {
    return this.httpClient
      .post(this.Customeroutes.getTodayAttendanceCheck(), '', {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          //if login is true the store it into local storage
          // localStorage.setItem('token', data.data.token);
          return data;
          // this.showSpinner=false;
        }
        return data;
      });
  }

  async getUserList() {
    return this.httpClient
      .post(this.Customeroutes.getUserList(), '', {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data.success == true) {

          return data;

        }
        return data;
      });
  }


  async getOldList(removed: any) {
    const olduser = { removed: removed }
    return this.httpClient
      .post(this.Customeroutes.getUserList(), olduser, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data.success == true) {

          return data;

        }
        return data;
      });
  }



  async getWFH(toggleid: any, togglestatus: any, _tracker: any) {
    const togglebody = { user_id: toggleid, isOn: togglestatus, tracker: _tracker }
    return this.httpClient
      .post(this.Customeroutes.getWFH(), togglebody, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data.success == true) {

          return data;

        }
        return data;
      });
  }

  async getAllUserSalariesMonthly(month: string, year: number, monthInt: number) {
    const postBody = {
      month_char: month || '',
      month_year: year || '',
      month_int: monthInt || ''
    };
    return this.httpClient
      .post(this.Customeroutes.getAllMonthSalaries(), postBody, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          //if login is true the store it into local storage
          // localStorage.setItem('token', data.data.token);
          return data;
          // this.showSpinner=false;
        }
        return data;
      });
  }

  async getUserAllSalaries(_userID: any,) {
    const postBody = {
      user_id: _userID || ''
    };
    return this.httpClient
      .post(this.Customeroutes.getUserAllSalries(), postBody, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          //if login is true the store it into local storage
          // localStorage.setItem('token', data.data.token);
          return data;
          // this.showSpinner=false;
        }
        return data;
      });
  }

  async getSalaryDetail(_userID: any,
    _salaryID: any,
    _start_date: any,
    _end_date: any) {
    const postBody = {
      user_id: _userID || '',
      salary_id: _salaryID || '',
      start_date: _start_date || '',
      end_date: _end_date || ''
    };
    return this.httpClient
      .post(this.Customeroutes.getUserSalryDetail(), postBody, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          //if login is true the store it into local storage
          // localStorage.setItem('token', data.data.token);
          return data;
          // this.showSpinner=false;
        }
        return data;
      });
  }

  async assignNewSalary(_userID: any,
    _monthChar: any,
    _monthYear: any,
    _monthInt: any) {
    const postBody = {
      user_id: _userID || '',
      month_char: _monthChar || '',
      month_year: _monthYear || '',
      month_int: _monthInt || '',
      status: "draft"
    };
    return this.httpClient
      .post(this.Customeroutes.assignNewSallary(), postBody, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          //if login is true the store it into local storage
          // localStorage.setItem('token', data.data.token);
          return data;
          // this.showSpinner=false;
        }
        return data;
      });
  }

  async saveGenratedSalary(reguest: any) {

    return this.httpClient
      .post(this.Customeroutes.saveGenratedSalary(), reguest, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          //if login is true the store it into local storage
          // localStorage.setItem('token', data.data.token);
          return data;
          // this.showSpinner=false;
        }
        return data;
      });
  }


  async loancounter(loanID: any) {
    return this.httpClient
      .post(this.Customeroutes.saveGenratedSalary(), loanID, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          //if login is true the store it into local storage
          // localStorage.setItem('token', data.data.token);
          return data;
          // this.showSpinner=false;
        }
        return data;
      });
  }



  async checkOutFromPortal(model: any) {
    return this.httpClient
      .post(this.Customeroutes.checkOutFromPortal(), model, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
        return data;
      });
  }

  async checkInFromPortal(model: any) {
    return this.httpClient
      .post(this.Customeroutes.checkInFromPortal(), model, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
        else if (data.success == false) {

          // Handle the specific condition here
        } else {
          // Handle the else case here
        }

        return data;
      });
  }



  async getuserdetail() {
    return this.httpClient
      .get(this.Customeroutes.userdetail(), {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),

      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data) {
          if (data.success == true) {

            return data;
          }
        }
        return data;
      });
  }


  async getleaves() {
    return this.httpClient
      .post(this.Customeroutes.getleavetype(), '', {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
        return data;
      });
  }



  async leaveCount(payment: any, leave_name: any, start_date: any, end_date: any, selectedLeaveType: any, otherUserId: any) {
    const postBody = {
      leave_name: leave_name,
      leave_payment_status: payment,
      start_date: start_date,
      end_date: end_date,
      leave_asign: selectedLeaveType,
      otheruserId: otherUserId,
    };
    return this.httpClient
      .post(this.Customeroutes.leaveCount(), postBody, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
        return data;
      });
  }




  upload(formData: any) {
    const token = localStorage.getItem('token');
    const url = this.Customeroutes.atendanceuploadsheet();
    const httpFormDataOptions = new HttpHeaders();
    return this.httpClient.post<any>(url, formData, { headers: httpFormDataOptions.append('Authorization', `Bearer ${token}`) });
  }



  async getuserrefresh() {
    return this.httpClient
      .post(this.Customeroutes.checkuserrefresh(), '', {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),

      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
        return data;
      });
  }



  getOrgnizations() {
    return this.httpClient
      .get(this.Customeroutes.getOrgnizations(), {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),

      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data) {
          if (data.success == true) {

            return data;
          }
        }
        return data;
      });
  }




  async changeOrgnization(id: any) {
    const postBody = {
      org_id: id,
    };
    return this.httpClient
      .post(this.Customeroutes.changeOrg(), postBody, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
        return data;
      });
  }

  async getusers() {
    return this.httpClient
      .post(this.Customeroutes.leaveotherusers(), '', {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
        return data;
      });
  }


  async getRemainingLeaves() {
    return this.httpClient
      .post(this.Customeroutes.RemainingLeaves(), '', {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
        return data;
      });
  }



  async getUserRemainingLeaves(id: any) {
    const postBody = {
      id: id,
    };
    return this.httpClient
      .post(this.Customeroutes.UserremainingLeaves(), postBody, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
        return data;
      });
  }


  async changetheme(id: any) {
    const postBody = {
      theme_id: id,
    };
    return this.httpClient
      .post(this.Customeroutes.themeChange(), postBody, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
        return data;
      });
  }


  async passwordReset() {
    return this.httpClient
      .post(this.Customeroutes.passwordReset(), '', {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
        return data;
      });
  }

  async pinReset() {
    return this.httpClient
      .post(this.Customeroutes.pinReset(), '', {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
        return data;
      });
  }



  async punchinlogs(time: any) {
    const postBody = {
      duration: time,
    };
    return this.httpClient
      .post(this.Customeroutes.punchinlogs(), postBody, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
        return data;
      });
  }


  async punchoutlogs(time: any) {
    const postBody = {
      duration: time,
    };
    return this.httpClient
      .post(this.Customeroutes.punchoutlogs(), postBody, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
        return data;
      });
  }

  async attendancetlogs(time: any) {
    const postBody = {
      duration: time,
    };
    return this.httpClient
      .post(this.Customeroutes.attendancetlogs(), postBody, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
        return data;
      });
  }


  async getNotification(limit: any) {
    const postBody = {
      limit: limit,
    };
    return this.httpClient
      .post(this.Customeroutes.adminNotification(), postBody, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
        return data;
      });
  }


  async claerNotifications() {
    return this.httpClient
      .post(this.Customeroutes.NotificationClear(), '', {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
        return data;
      });
  }
  async notify(id: any) {
    const postBody = {
      notify_id: id,
    };
    return this.httpClient
      .post(this.Customeroutes.singleNotification(), postBody, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
        return data;
      });
  }



  async getAnnouncement() {
    return this.httpClient
      .post(this.Customeroutes.latestAnnouncement(), '', {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
        return data;
      });
  }



  async todayAttendance() {
    return this.httpClient
      .post(this.Customeroutes.settodayattendance(), '', {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
        return data;
      });
  }



  async getEvaluation(id: any) {
    const postBody = {
      id: id,
    };
    return this.httpClient
      .post(this.Customeroutes.latestEvaluation(), postBody, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
        return data;
      });
  }



  async getaddressSuggestion(query: any) {
    return this.httpClient
      .get(this.Customeroutes.addressSugestion(query), {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),

      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data) {
          if (data.success == true) {

            return data;
          }
        }
        return data;
      });
  }



  async getaddressLatlong(query: any) {
    return this.httpClient
      .get(this.Customeroutes.addressdetail(query), {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),

      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data) {
          if (data.success == true) {

            return data;
          }
        }
        return data;
      });
  }


  genrateAllPayroll(month_char: any, year: any, month_in: any) {
    const postBody = {
      "month_int": month_in,
      "month_char": month_char,
      "month_year": year
    };
    return this.httpClient
      .post(this.Customeroutes.generatePayroll(), postBody, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
        return data;
      });
  }



  getPayrollProgress(month_in: number, year: number): Promise<any> {
    const url = this.Customeroutes.getPayrollProgress(month_in, year);

    return this.httpClient
      .get(url, {
        headers: this.HeaderService.getHeaderWithToken(localStorage.getItem('token'))
      })
      .toPromise()
      .then((data: any) => {
        return data; // Caller can check data.success
      })
      .catch((error) => {
        console.error('Error fetching payroll progress:', error);
        throw error;
      });
  }



  genrateSelectedPayroll(ids: any, status: any) {
    const postBody = {
      "salary_ids": ids,
      "status": status,
    };
    return this.httpClient
      .post(this.Customeroutes.generateSelectedPayroll(), postBody, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
        return data;
      });
  }


  bulkActionPayroll(year: any, month_in: any, status: any) {
    const postBody = {
      'action': status,
      'month_int': month_in,
      'month_year': year,
    };
    return this.httpClient
      .post(this.Customeroutes.bulkActionPayroll(), postBody, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
        return data;
      });
  }




  async userGenerateSalary(monthInt: number, month: string, year: number, user_id: number) {
    const postBody = {
      month_char: month || '',
      month_year: year || '',
      month_int: monthInt || '',
      user_id: user_id || '',
    };
    return this.httpClient
      .post(this.Customeroutes.generateUserSalary(), postBody, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          //if login is true the store it into local storage
          // localStorage.setItem('token', data.data.token);
          return data;
          // this.showSpinner=false;
        }
        return data;
      });
  }


  async updateUserSalary(payload: any) {

    return this.httpClient
      .post(this.Customeroutes.updateUserSalary(), payload, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          //if login is true the store it into local storage
          // localStorage.setItem('token', data.data.token);
          return data;
          // this.showSpinner=false;
        }
        return data;
      });
  }




  async getCounts(id: any, month_int: any = null, year: any = null) {
    const postBody: any = {
      id: id
    };
    if (month_int) postBody.month_int = month_int;
    if (year) postBody.year = year;
    return this.httpClient
      .post(this.Customeroutes.getCounts(), postBody, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          //if login is true the store it into local storage
          // localStorage.setItem('token', data.data.token);
          return data;
          // this.showSpinner=false;
        }
        return data;
      });
  }







  async reset2FAUser(user_id: any) {
    const postBody = {
      user_id: user_id || ''
    };
    return this.httpClient
      .post(this.Customeroutes.resetUser2FA(), postBody, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          //if login is true the store it into local storage
          // localStorage.setItem('token', data.data.token);
          return data;
          // this.showSpinner=false;
        }
        return data;
      });
  }



  async enable2FAUser(user_id: any, isEnabled: any) {
    const postBody = {
      user_id: user_id || '',
      enable: isEnabled
    };
    return this.httpClient
      .post(this.Customeroutes.enableUser2FA(), postBody, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          //if login is true the store it into local storage
          // localStorage.setItem('token', data.data.token);
          return data;
          // this.showSpinner=false;
        }
        return data;
      });
  }


  
  async getUserSalary(user_id: any,month_int:any, month_Year:any) {
    const postBody = {
      user_id: user_id,
      month_int:month_int,
      month_year:month_Year
    };
    return this.httpClient
      .post(this.Customeroutes.fetchUserSalary(), postBody, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          //if login is true the store it into local storage
          // localStorage.setItem('token', data.data.token);
          return data;
          // this.showSpinner=false;
        }
        return data;
      });
  }



  async getAllUserSalariesCurrnetMonthly() {
    
    return this.httpClient
      .post(this.Customeroutes.getcurrentMonthSalaries(), '', {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          //if login is true the store it into local storage
          // localStorage.setItem('token', data.data.token);
          return data;
          // this.showSpinner=false;
        }
        return data;
      });
  }




async setShiftTime(payload: any,) {
  
    const shifts = {
      shifts: payload
    };
    return this.httpClient
      .post(this.Customeroutes.setShiftTime(), shifts, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          //if login is true the store it into local storage
          // localStorage.setItem('token', data.data.token);
          return data;
          // this.showSpinner=false;
        }
        return data;
      });
  }


  
  


  async getMyAttendanceCorrections(filters: any = {}) {
    return this.httpClient
      .post(this.Customeroutes.getMyAttendanceCorrections(), filters, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
        return data;
      });
  }

}
